<template>
    <!-- 主容器 -->
    <div class="yx-div">
        <!-- 工具栏 -->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div class="yx-flex-h-start2">
                    <div>
                        检索：
                        <el-input placeholder="查询内容" v-model="searchVal.keyword" clearable class="input-with-select" style="width: 400px">
                            <el-select v-model="searchVal.keywordMethod" slot="prepend" placeholder="选择关键字" class="el-select-with-input">
                                <el-option
                                        v-for="item in keywordList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-input>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="searchDo">查询</el-button>
                    <el-button type="warning" @click="showFV = !showFV">
                        <i :class="showFV?'fa fa-angle-double-up':'fa fa-angle-double-down'" aria-hidden="true"></i>
                    </el-button>
                </div>
            </div>
            <div v-show="showFV" >
                <div  class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>
                        设备型号：
                        <el-select v-model="searchVal.devModelId" placeholder="设备型号" size="mini" clearable filterable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in devModels"
                                    :key="item.id"
                                    :label="item.model"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        仓储状态：
                        <el-select v-model="searchVal.devStrStatId" placeholder="仓储状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevStorageStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        调拨状态：
                        <el-select v-model="searchVal.devDbStat" placeholder="调拨状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevDbStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        绑定状态：
                        <el-select v-model="searchVal.devBindStat" placeholder="绑定状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevBindStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div  class="yx-flex-h-start" style="margin-top: 15px;">
                    <div>
                        分配状态：
                        <el-select v-model="searchVal.devFpStat" placeholder="分配状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevFpStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        预设费率：
                        <el-select v-model="searchVal.preSetRate" placeholder="预设费率" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.QrPreSetRateEnum"
                                    :key="item.id"
                                    :label="item.desc"
                                    :value="item.name">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        激活状态：
                        <el-select v-model="searchVal.devActStatId" placeholder="激活状态" size="mini" clearable
                                   style="width: 150px;margin-right: 15px;">
                            <el-option
                                    v-for="item in this._enums.DevActiveStatusEnum"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div>
                        入库日期：
                        <el-date-picker
                                v-model="searchVal.purDateScope"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                size="mini"
                                style="width:250px"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <div class="yx-flex-h-start" style="margin-top: 15px;">
                <el-button type="danger" icon="el-icon-plus" @click="viewAdd">入库</el-button>
                <el-button type="danger" icon="el-icon-link" @click="TerUnbind" :disabled="disableBtn">解绑商户(非必要)</el-button>
                <el-dropdown trigger="click" @command="TerSetRate">
                    <el-button type="success" icon="el-icon-setting" @click="" :disabled="disableBtn" style="margin-left: 10px;">
                        个性化费率(非必要) <i class="el-icon-arrow-down el-icon--right" />
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item,index) in this._enums.QrPreSetRateEnum" :key=index :command="item.id">
                            <div style="width: 100px;text-align: center">{{item.desc}}</div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!--
                <el-button type="danger" icon="el-icon-truck" @click="showAddEmpView">调拨</el-button>
                <el-button type="danger" icon="el-icon-cpu" @click="showAddEmpView">维修</el-button>
                -->
            </div>
        </div>

        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :cell-style="columnbackgroundStyle"
                    :data="devices"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%">
                <el-table-column type="selection" align="center" />
                <el-table-column prop="devModel.model" label="型号" width="100" />
                <el-table-column prop="terSn" label="终端SN" width="120" />
                <el-table-column prop="preSetRate" label="预设费率" width="100" align="center">
                    <template slot="header">
                        <el-tooltip effect="light" placement="top">
                            <!--
                            <div slot="content" >
                                <el-tag type="success" effect="light">
                                    <span>预设费率 + D0垫资: <span class="cls-rate">0.02%</span>，单笔最低<span class="cls-rate">0.01</span>元</span>
                                </el-tag>
                                <br><br>
                                先出码给商户，商户通过扫码自行提交商户进件资料信息时，
                                <br>
                                使用到此参数，可在出码前，修改码牌的预设费率。
                                <br><br>
                                <el-tag type="info" effect="light">商户自进件</el-tag>
                                - 先出码牌，以码牌预先设定的费率为准。
                                <br><br>
                                <el-tag type="info" effect="light">先进件商户</el-tag>
                                - 后绑码牌，以进件商户设定的费率为准。
                            </div>
                            -->
                            <span style="color: green;">预设费率 <i class="el-icon-question"/></span>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.devBindStat!==2" type="success" effect="light">
                            {{scope.row.preSetRate}}%
                        </el-tag>
                    </template>
                </el-table-column>

                <!--
                <el-table-column prop="devModel.supplier" label="设备商" width="70" />
                <el-table-column prop="devModel.type" label="类别" width="100" />
                -->
                <!--
                <el-table-column label="分配状态" width="100" >
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.inAgentId==='1'" color="#FFFFFF">未分配</el-tag>
                        <el-tag type="info" v-else color="#FFFFFF">已分配</el-tag>
                    </template>
                </el-table-column>
                -->
                <el-table-column prop="devStrStat" label="仓储状态" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag effect="plain" :type="scope.row.devStrStat===1?'default':'danger'">{{_enums.DevStorageStatusEnum.getNameById(scope.row.devStrStat)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="devBindStat" label="绑定状态" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag effect="dark" :type="scope.row.devBindStat===2?'success':'info'">{{_enums.DevBindStatusEnum.getNameById(scope.row.devBindStat)}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="inMchName" label="绑定商户" width="100" show-overflow-tooltip />
                <!--
                <el-table-column prop="devActStat" label="激活状态" width="100">
                    <template slot-scope="scope">{{_enums.DevActiveStatusEnum.getNameById(scope.row.devActStat)}}</template>
                </el-table-column>
                -->
                <el-table-column prop="inAgent.name" label="当前归属" width="150" show-overflow-tooltip />
                <el-table-column prop="inSaleName" label="客户经理" width="80" show-overflow-tooltip />
                <!--
                <el-table-column prop="inDateTime" label="调拨时间" width="150" />
                -->
                <el-table-column prop="purBatNo" label="入库批次" width="100" align="center" />
                <el-table-column prop="purDateTime" width="150" label="入库时间" sortable align="center"  />
                <el-table-column fixed="right" label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.payQr" type="text" size="mini" style="padding: 5px" @click="viewDetail(scope.row.payQr)">下载码牌</el-button>
                    </template>
                </el-table-column>

            </el-table>
        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-between">
            <div style="width: 1px" />
            <!--
            <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
            -->
            <div class="yx-flex-v">
                <!--
                <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
                -->
                <el-tag type="info" style="margin-left: 0px;">
                    <i class="header-icon el-icon-info"></i>
                    状态统计：&nbsp;&nbsp;
                    {{totalTxt}}
                </el-tag>
            </div>
            <el-pagination
                    background
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="slot, sizes, prev, pager, next, jumper, total"
                    :pager-count="5"
                    :total="total">
                <!--
                <span>共计{{total}}台&nbsp;&nbsp;</span>
                -->
            </el-pagination>
        </div>

        <el-dialog
                :title="titleDlg"
                :visible.sync="showDlg"
                :lock-scroll="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                :destroy-on-close="true"
                width="60%"
                class="dlg-normal">
            <div style="height: 380px; margin-top: 5px; overflow-y: auto;">
                <el-form :model="insDevInfoForm" :rules="rules" ref="insDevInfoForm">
                    <div class="form-s">
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="入库批次" prop="purBatNo">
                                    <el-input size="small" v-model="insDevInfoForm.purBatNo" :disabled="true" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="仓库名称" prop="abc">
                                    <el-input size="small" v-model="insDevInfoForm.abc" :disabled="true" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="仓储状态" prop="devStrStat">
                                    <el-select v-model="insDevInfoForm.devStrStat" size="small" :disabled="true"
                                               style="width: 100%;">
                                        <el-option
                                                v-for="item in this._enums.DevStorageStatusEnum"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="激活状态" prop="devActStat">
                                    <el-select v-model="insDevInfoForm.devActStat" size="small" :disabled="true"
                                               style="width: 100%;">
                                        <el-option
                                                v-for="item in this._enums.DevActiveStatusEnum"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="30">
                            <el-col :span="12">
                                <el-form-item label="设备型号" prop="modelId">
                                    <el-select v-model="insDevInfoForm.modelId" size="small" placeholder="设备型号"
                                               style="width: 100%;">
                                    <el-option
                                                v-for="item in devModels"
                                                :key="item.id"
                                                :label="item.model"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="产品类型" prop="devActStat">
                                    <el-select v-model="insDevInfoForm.channelCode" size="small"
                                               style="width: 100%;">
                                        <el-option
                                                v-for="item in this._enums.ProductChannelConvertEnum"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="设备序号" prop="termSnTxt">
                                    <el-input type="textarea" :rows="8" size="small" v-model="insDevInfoForm.termSnTxt"  placeholder="终端SN，换行，“-”批量录入号段，例如001-005"  />
                                </el-form-item>
                            </el-col>
                        </el-row>

                    </div>

                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="yx-flex-h-between">
                    <div class="yx-flex-v">
                        <el-tag type="info" style="margin-left: 10px">
                            <i class="header-icon el-icon-info"></i>
                            预入库：&nbsp;&nbsp;
                            型号：{{devMod}}&nbsp;&nbsp;
                            数量：{{devCnt}}&nbsp;&nbsp;
                        </el-tag>
                    </div>
                    <div>
                        <el-button size="small" @click="showDlg = false">取 消</el-button>
                        <el-button size="small" type="primary" @click="dlgCommit">确 定</el-button>
                    </div>
                </div>

            </span>
        </el-dialog>

        <el-drawer
                class="drw"
                title="支付码"
                :visible.sync="drawer"
                size = "50%"
                direction="rtl">
            <QrDetailDiv :key="detailData.id" :in-detail-data="detailData" v-bind:outDrawerClose.sync="drawerRe"></QrDetailDiv>
        </el-drawer>
    </div>

</template>

<script>

    import {
        URL_DEV_MODELS,
        URL_DATA_PURBATNO
    } from "../../utils/cons";
    import AreaSelect from "../../components/pub/AreaSelect";
    import QrDetailDiv from "../../components/qr/QrDetailDiv";

export default {
        name: "DevPurch",
    components: {AreaSelect, QrDetailDiv},
    data() {
            return {
                title: '',
                showFV: false,
                drawer: false,
                detailData:{},
                drawerRe: false,
                dialogVisible: false,
                loading: false,
                total: 0,
                totalTxt:'',
                page: 1,
                size: 10,
                titleDlg: '',
                showDlg: false,
                devices: [],
                devModels: [],
                searchVal: {
                    keywordMethod: '',
                    keyword: '',
                    purDateScope: null,
                    devModelId: null,
                    devStrStatId: null,
                    devActStatId: null,
                    devBindStat: null,
                    devDbStat: null,
                    devFpStat: null,
                    preSetRate: null
                },
                keywordList: [
                    {id:"inAgentName",name:"所属服务商"},
                    {id:"terSn",name:"终端SN"}
                ],
                devCnt: 0,
                devObj: {total:0,tsnLst:null},
                devMod: '',
                devDetail: {
                    terSn: null
                },
                initDevInfoForm: {
                    modelId: null,
                    termSnTxt: null,
                    devDetails: [],
                    abc:'主仓库',
                    purBatNo:null,
                    purDateTime:null,
                    devStrStat:1,
                    devActStat:1,
                    inAgentId:1,
                    inAgentName:null,
                    inDateTime:null
                },
                insDevInfoForm: {
                    channelCode: null,
                    modelId: null,
                    termSnTxt: null,
                    devDetails: [],
                    abc:'主仓库',
                    purBatNo:null,
                    purDateTime:null,
                    devStrStat:1, //仓储状态 默认1.在库
                    devActStat:1, //激活状态 默认1.空置
                    inAgentId:1,  //所属服务商 默认1.公司
                    inAgentName:null,
                    inDateTime:null
                },
                insDevInfoList: [],
                insDevInfo: {
                    channelCode: null,
                    modelId:null,
                    terSn:null,
                    purBatNo:null,
                    devStrStat:null,
                    devActStat:null
                },
                disableBtn: true,
                multipleSelection: [],
                DevBindForm: {
                    mchName: null,
                    saleName: null,
                    devSnTxt: null,
                    mchId: null,
                    saleId: null,
                    devIds: []
                },
                rules: {
                    abc: [{required: true, message: '', trigger: 'blur'}],
                    purBatNo: [{required: true, message: '', trigger: 'blur'}],
                    devStrStat: [{required: true, message: '', trigger: 'blur'}],
                    devActStat: [{required: true, message: '', trigger: 'blur'}],
                    modelId: [{required: true, message: '请选择设备型号', trigger: 'blur'}],
                    termSnTxt: [{required: true, message: '请输入设备序列号', trigger: 'blur'}],
                }
            }
        },
        watch:{
            insDevInfoForm: {
                handler:function(val) {

                    for(let i=0;i<this.devModels.length;i++) {
                        if(this.insDevInfoForm.modelId==this.devModels[i].id) {
                            this.devMod = this.devModels[i].model;
                            break;
                        }
                    }

                    if(this.insDevInfoForm.termSnTxt && this.insDevInfoForm.termSnTxt.length>0) {
                        this.devObj = this._StringUtils.batTermSn(this.insDevInfoForm.termSnTxt);
                        if(this.devObj) {
                            this.devCnt = this.devObj.total;
                        }
                        else {
                            this.devCnt = 'x--x--x 格式错 x--x--x';
                        }
                    }
                },
                deep:true
            }
        },
        mounted() {
            this.initDevices();
            this.getRequest(URL_DEV_MODELS).then(resp => { if (resp) this.devModels = resp.data });
        },
        methods: {
            // 改变Table某一列的背景颜色
            // columnIndex为列下标
            columnbackgroundStyle({ row, column, rowIndex, columnIndex }) {
                if (column.label == '操作') {
                    //让下标为1的列数背景颜色显示为红色（颜色自定义根据大家需求来）
                    return 'background:#fafafa;'
                }
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initDevices();
            },
            viewDetail(data) {
                Object.assign(this.detailData, data);
                this.drawer = true;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if(this.multipleSelection.length>0) {
                    this.disableBtn = false;
                }
                else {
                    this.disableBtn = true;
                }
            },
            TerUnbind() {
                this.DevBindForm.devIds = [];
                this.multipleSelection.forEach( item => {
                    if(item.devBindStat === this._enums.DevBindStatusEnum.已绑定.id ) {
                        this.DevBindForm.devIds.push(item.id);
                    }
                });

                if(this.DevBindForm.devIds.length===0) {
                    this.$message.error("没有需要解绑的设备 !");
                    return;
                }

                this.$confirm( '解绑设备 ' + this.DevBindForm.devIds.length + ' 台' , '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'danger'
                }).then(() => {
                    this.putRequest("/dev/devUnBind" + "?devIds=" + this.DevBindForm.devIds).then(resp => {
                        if (resp) {
                            this.initDevices();
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            TerSetRate(command) {
                let rate = this._enums.QrPreSetRateEnum.getNameById(command);
                let desc = this._enums.QrPreSetRateEnum.getDescById(command);
                let ids = [];
                try {
                    this.multipleSelection.forEach( item => {
                        if(item.devStrStat !== this._enums.DevStorageStatusEnum.在库.id ) {
                            throw ("设备未在库中 ! 序列号：" + item.terSn);
                        }
                        if(item.devBindStat !== this._enums.DevBindStatusEnum.未绑定.id ) {
                            throw ("设备已被绑定 ! 序列号：" + item.terSn);
                        }
                        if(item.inSaleId && this.$store.state.currentHr.type!==3) {
                            throw ("设备已分配客户经理，请先回收 ! 序列号：" + item.terSn);
                        }
                        ids.push(item.id);
                    });
                    this.$confirm('对选中的【' + this.multipleSelection.length + '】个码牌重设费率为【' + desc + '】？',
                        '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                        this.loading = true;
                        this.putRequest("/dev/devSetRate" + "?preSetRate=" + rate + "&devIds=" + ids).then(resp => {
                            if (resp) {
                                this.loading = false;
                                this.initDevices();
                            }
                        });
                    }).catch(() => {
                        this.$message({ type: 'info', message: '已取消' });
                    });
                }
                catch (e) {
                    this.$message.error(e);
                    return;
                }
            },
            exportData() {
                let urlParam = '/dev/devInfoAll/export?page=1';

                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    urlParam += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.devModelId) {
                    urlParam += '&modelId=' + this.searchVal.devModelId;
                }
                if (this.searchVal.devStrStatId) {
                    urlParam += '&devStrStat=' + this.searchVal.devStrStatId;
                }
                if (this.searchVal.devActStatId) {
                    urlParam += '&devActStat=' + this.searchVal.devActStatId;
                }
                if (this.searchVal.devBindStat) {
                    urlParam += '&devBindStat=' + this.searchVal.devBindStat;
                }
                if(this.searchVal.devDbStat) {
                    urlParam += '&inAgentId='  + this.searchVal.devDbStat;
                }
                if(this.searchVal.devFpStat) {
                    urlParam += '&devFpStat='  + this.searchVal.devFpStat;
                }
                if (this.searchVal.purDateScope) {
                    urlParam += '&purDateScope=' + this.searchVal.purDateScope;
                }

                window.open(urlParam, '_parent');
            },
            initDevices() {
                this.loading = true;
                let urlParam = '?page=' + this.page + '&size=' + this.size;

                if (this.searchVal.keywordMethod && this.searchVal.keyword) {
                    urlParam += '&'+this.searchVal.keywordMethod+'=' + this.searchVal.keyword;
                }
                if (this.searchVal.devModelId) {
                    urlParam += '&modelId=' + this.searchVal.devModelId;
                }
                if (this.searchVal.devStrStatId) {
                    urlParam += '&devStrStat=' + this.searchVal.devStrStatId;
                }
                if (this.searchVal.devActStatId) {
                    urlParam += '&devActStat=' + this.searchVal.devActStatId;
                }
                if (this.searchVal.devBindStat) {
                    urlParam += '&devBindStat=' + this.searchVal.devBindStat;
                }
                if(this.searchVal.devDbStat) {
                    urlParam += '&inAgentId='  + this.searchVal.devDbStat;
                }
                if(this.searchVal.devFpStat) {
                    urlParam += '&devFpStat='  + this.searchVal.devFpStat;
                }
                if(this.searchVal.preSetRate) {
                    urlParam += '&preSetRate='  + this.searchVal.preSetRate;
                }
                if (this.searchVal.purDateScope) {
                    urlParam += '&purDateScope=' + this.searchVal.purDateScope;
                }

                this.getRequest("/dev/devInfoAll" + urlParam).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.devices = resp.data;
                        this.total = resp.total;
                    }
                });

                this.totalTxt = '';
                this.getRequest("/dev/devInfoStatActTotal" + urlParam).then(resp => {
                    this.loading = false;
                    if (resp) {
                        let ar = resp.data;
                        this.totalTxt = ar[0];
                    }
                });

            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initDevices();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initDevices();
            },
            viewAdd() {
                this.titleDlg = '设备入库';
                this.insDevInfoList = [];
                Object.assign(this.insDevInfoForm, this.initDevInfoForm);
                this.getPurBatNo();
                this.showDlg = true;
            },
            getPurBatNo() {
                this.getRequest(URL_DATA_PURBATNO).then(resp => { if (resp) this.insDevInfoForm.purBatNo = resp.obj.no });
            },
            dlgCommit() {
                this.insertDevInfo();
            },
            insertDevInfo() {

                this.insDevInfoList = [];

                this.$refs['insDevInfoForm'].validate(valid => {
                    if (valid) {
                        if(this.devObj) {
                            for(let i=0;i<this.devObj.total;i++) {
                                this.insDevInfo = {};
                                this.insDevInfo.channelCode = this.insDevInfoForm.channelCode;
                                this.insDevInfo.modelId = this.insDevInfoForm.modelId;
                                this.insDevInfo.purBatNo = this.insDevInfoForm.purBatNo;
                                this.insDevInfo.devStrStat = this.insDevInfoForm.devStrStat;
                                this.insDevInfo.devActStat = this.insDevInfoForm.devActStat;
                                this.insDevInfo.terSn = this.devObj.tsnLst[i];
                                this.insDevInfoList.push(this.insDevInfo);
                            }
                        }
                        else {
                            this.$message({
                                type: 'info',
                                message: '序列号格式错'
                            });
                            return;
                        }

                        this.$confirm('入库型号：' + this.devMod + '，数量：' + this.devCnt + '台', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {

                            this.postRequest("/dev/addDevInfo", this.insDevInfoList).then(resp => {
                                if (resp) {
                                    this.initDevices();
                                    this.showDlg = false;
                                }
                            })

                        }).catch(() => {
                            this.$message({
                                type: 'info',
                                message: '已取消'
                            });
                        });
                    }
                });


            }
        }

    }
</script>

<style scoped>

</style>
